var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from '../../styled';
import button from '../../themes/buttons';
import LoadingSpinner from '../loadingSpinner';
import { LoadingSpinnerWrapper, ContentWrapper, Container } from './elements';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const generateHeightStyle = (buttonTheme, height = 'MEDIUM') => {
    return css `
    &,
    & * {
      line-height: ${({ theme }) => theme[buttonTheme].height[height]};
      height: ${({ theme }) => theme[buttonTheme].height[height]};
    }
  `;
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const generateWidthStyle = (buttonTheme, width = 'NORMAL') => {
    return css `
    & {
      min-width: ${({ theme }) => theme[buttonTheme].minWidth[width]};
      padding: 0
        calc(
          ${({ theme }) => theme[buttonTheme].hPadding[width]} -
            ${({ theme }) => theme[buttonTheme].border.NORMAL}
        );
    }
  `;
};
const StyledContainer = styled(Container) `
  ${props => generateHeightStyle(props.buttonTheme, props.height)}
  ${props => generateWidthStyle(props.buttonTheme, props.width)}

  border-radius: ${({ theme, borderRadius = 'NORMAL', buttonTheme }) => theme[buttonTheme].borderRadius[borderRadius]}

  &.is-focus {
    padding-left: calc(
      ${({ theme, width = 'NORMAL', buttonTheme }) => theme[buttonTheme].hPadding[width]} -
        ${({ theme, buttonTheme }) => theme[buttonTheme].border.BOLD}
    );
    padding-right: calc(
      ${({ theme, width = 'NORMAL', buttonTheme }) => theme[buttonTheme].hPadding[width]} -
        ${({ theme, buttonTheme }) => theme[buttonTheme].border.BOLD}
    );
  }
`;
const getTagName = (isLink, disabled, isLoading) => {
    return isLink && !disabled && !isLoading ? 'a' : 'button';
};
const map = {
    defaultButton: 'buttons',
    clearButton: 'clearButtons',
};
const buttonGenerator = (buttonTheme, buttonKey, isLink) => (_a) => {
    var { children, Icon, isLoading, disabled, focus, iconPosition, iconAlign = 'LEFT', className = '', e2eId } = _a, restProps = __rest(_a, ["children", "Icon", "isLoading", "disabled", "focus", "iconPosition", "iconAlign", "className", "e2eId"]);
    const props = {
        as: getTagName(isLink, disabled, isLoading),
        className: `${className} ${focus ? 'is-focus' : ''}`,
        buttonKey,
        buttonTheme: map[buttonTheme],
        disabled: isLoading || disabled,
        isLoading,
    };
    return (React.createElement(StyledContainer, Object.assign({}, props, restProps, { "data-e2e-id": e2eId }),
        isLoading && (React.createElement(LoadingSpinnerWrapper, { buttonKey: buttonKey, buttonTheme: map[buttonTheme] },
            React.createElement(LoadingSpinner, null))),
        React.createElement(ContentWrapper, { isLoading: isLoading, buttonKey: buttonKey, buttonTheme: map[buttonTheme] },
            children && iconAlign === 'RIGHT' && React.createElement("span", null, children),
            Icon && (React.createElement(Icon, { position: iconPosition, size: "MEDIUM", color: button.types[buttonKey].iconColor })),
            children && iconAlign === 'LEFT' && React.createElement("span", null, children))));
};
export default buttonGenerator;
//# sourceMappingURL=buttonGenerator.js.map